export default "__VITE_ASSET__BwBqDIB9__"